/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScheduleType } from '@gh/builder-shared-data';
import { dictionaryValueFormatter } from '@gh/common-internal-shared';
import { EnumDictionary, getRouteInitData } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { ManualGridDefinition } from '@gh/core-ui-grid';

import { ColDef, GridOptions } from 'ag-grid-community';


@Injectable()
export class ScheduleTemplateGridDefinition extends ManualGridDefinition {

  scheduleType: EnumDictionary<ScheduleType>;

  constructor(private route: ActivatedRoute,
              private translationService: TranslationService) {
    super();

    const { scheduleType } = getRouteInitData(route);
    this.scheduleType = scheduleType;
  }

  buildGridOptions(): GridOptions {
    return {
      getRowId: (params) => String(params.data.id),
    };
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'name',
      width: 250,
      headerName: this.translationService.get('lbl_name'),
    }, {
      field: 'type',
      headerName: this.translationService.get('lbl_type'),
      valueFormatter: dictionaryValueFormatter(this.scheduleType),
    }];
  }

}
